module.exports = __webpack_public_path__ + "static/footer-956c6175b67ec027b95011427a6cb71d.png";